export default __webpack_public_path__ + "static/media/logo-dark.3a6105c1.jpg";